import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Button } from "antd";
import { ButtonProps } from "./button.types";

const buttonCSS = (size) => {
    switch (size) {
        case "medium":
            return css`
                height: 36px;
                padding: 2px 12px;
            `;
        case "regular":
            return css`
                height: 32px;
                padding: 0px 8px;
            `;
        case "small":
            return css`
                height: 24px;
                padding: 0px 12px;
            `;
        case "large":
            return css`
                height: 40px;
                padding: 0px 16px;
            `;
        default:
            return css``; // Default to an empty CSS block
    }
};

export const StyledButton = styled(Button)<ButtonProps>`
    box-shadow: none;
    ${({ size }) => buttonCSS(size)}
`;
